import { LIVE_URL } from './runtimeConfig';

let listeners = [];
let retries = 0;

const socket = {
	current: null,
	roomName: 'default',
	// Returns false (instead of throwing) when the connection isn't open, e.g. while reconnecting.
	send: (eventName, data) => {
		const ws = socket.current;
		if (!ws || ws.readyState !== 1) return false;
		ws.send(JSON.stringify({ ...data, eventName }));
		return true;
	},
	on: (eventName, listener) => {
		listener.eventName = eventName;
		listeners.push(listener);
	},
	off: (listener) => (listeners = listeners.filter((l) => l !== listener)),
	joinRoom: (roomName) => {
		socket.roomName = roomName;
		socket.send(null, { join_room: roomName });
	}
};

const socket_connect = () => {
	const ws = new WebSocket(LIVE_URL);
	socket.current = ws;
	ws.onmessage = (m) => {
		let message;
		try {
			message = JSON.parse(m.data);
		} catch (error) {
			return;
		}
		listeners.slice().forEach((l) => {
			if (l.eventName === message.eventName) l(message);
		});
	};
	// Reconnect with exponential backoff (1s, 2s, 4s ... max 15s) plus jitter so that a server restart
	// doesn't bring every phone back in the same instant.
	ws.onclose = () => {
		if (socket.current !== ws) return;
		const delay = Math.min(1000 * 2 ** retries++, 15000) + Math.random() * 500;
		setTimeout(socket_connect, delay);
	};
	ws.onerror = (error) => console.log(`Socket error`, error && error.message);
	ws.onopen = () => {
		retries = 0;
		socket.send(null, { join_room: socket.roomName });
	};
};
socket_connect();

export default socket;
